import React, { ReactNode } from 'react'
import { FormItem as FI } from 'ui-kit-sber'
import { FormItemProps } from 'antd/es/form'
import styled from 'styled-components'
import { STypographyDefault } from '@components/Typography'
import { r } from '@utils/styles/functions'
import IconTooltip from '@components/IconTooltip'
import Box from '@components/Box'

const SFormItem = styled(FI)`
  position: relative;
`

const SHolder = styled.div``
const SLabel = styled.label`
  padding-bottom: ${r(8)};
`

const SecondLabel = styled(STypographyDefault)<{ secondLabel?: string | React.ReactNode; confirmed?: boolean }>`
  position: absolute;
  top: 0;
  right: 0;

  ${(props) =>
    !props.secondLabel &&
    `
    color: ${props.theme.colors.gray};
  `}
`

export type TTooltip = {
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  children?: string | ReactNode
}
export interface IFormItem extends FormItemProps {
  itemId?: string
  secondLabel?: string | ReactNode
  confirmed?: boolean
  tooltip?: TTooltip
}

const FormItem: React.FC<IFormItem> = ({
  secondLabel,
  itemId,
  confirmed,
  children,
  label,
  tooltip,
  ...formItemProps
}) => {
  const hasSecondLabel: boolean = confirmed !== undefined || !!secondLabel
  const defaultLabelText = confirmed ? 'Подтвержден' : 'Не подтвержден'

  return (
    <SFormItem {...formItemProps}>
      <SHolder>
        <Box display="flex">
          {label && <SLabel htmlFor={itemId}>{label}</SLabel>}
          {tooltip && (
            <Box pl={r(5)}>
              <IconTooltip icon={tooltip.icon}>{tooltip.children}</IconTooltip>
            </Box>
          )}
        </Box>
        {children}
        {hasSecondLabel && (
          <SecondLabel secondLabel={secondLabel} confirmed={confirmed}>
            {secondLabel ? secondLabel : defaultLabelText}
          </SecondLabel>
        )}
      </SHolder>
    </SFormItem>
  )
}

export default FormItem
